import { useEffect, useState } from 'react';
import { Button, Input, Empty, Typography, Modal, Table, Form, Select } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined, PlayCircleOutlined } from '@ant-design/icons';
import UploadMedia from '../../../../components/Upload/UploadMedia';
import { useSingleService } from './SingleServiceStore';
import api from '../../../../api/axios';

const { Text } = Typography;

function Songs({ serviceId }) {
    const { songs, getSongs, addSong, updateSong, deleteSong } = useSingleService();
    const [modalOpen, setModalOpen] = useState(false);
    const [editRecord, setEditRecord] = useState(null);
    const [form] = Form.useForm();
    const [filePath, setFilePath] = useState('');
    const [genre, setGenre] = useState([])

    useEffect(() => {
        if (serviceId) getSongs(serviceId);
        api.get('genres').then(res=>setGenre(res.data.data))
    }, [serviceId, getSongs]);

    const openAdd = () => {
        setEditRecord(null);
        setFilePath('');
        form.resetFields();
        setModalOpen(true);
    };

    const openEdit = (record) => {
        setEditRecord(record);
        setFilePath(record.file_path || '');
        form.setFieldsValue(record);
        setModalOpen(true);
    };

    const handleSubmit = (values) => {
        values.file_path = filePath;
        values.services_id = serviceId;
        const promise = editRecord
            ? updateSong(editRecord.id, { ...values, id: editRecord.id })
            : addSong(values);
        promise?.then(() => {
            setModalOpen(false);
            form.resetFields();
            setFilePath('');
        });
    };

    const handleDelete = (record) => {
        Modal.confirm({
            title: "Qo'shiqni o'chirishni tasdiqlang",
            okText: "O'chirish", okType: 'danger', cancelText: 'Bekor qilish',
            onOk: () => deleteSong(record.id, serviceId),
        });
    };

    const columns = [
        { title: 'Nomi', dataIndex: 'title', key: 'title' },
        { title: 'Mavzu', dataIndex: 'theme', key: 'theme' },
        {
            title: 'Fayl', dataIndex: 'file_path', key: 'file_path',
            render: (path) => path ? (
                <a href={process.env.REACT_APP_URL + path} target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <PlayCircleOutlined /> Tinglash
                </a>
            ) : '—',
        },
        {
            title: '', key: 'actions', width: 80,
            render: (_, rec) => (
                <div style={{ display: 'flex', gap: 4 }}>
                    <Button type="primary" size="small" icon={<EditOutlined />} onClick={() => openEdit(rec)} />
                    <Button type="primary" danger size="small" icon={<DeleteOutlined />} onClick={() => handleDelete(rec)} />
                </div>
            ),
        },
    ];

    return (
        <div style={{ padding: '16px 0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <Text strong style={{ fontSize: 16 }}>Qo'shiqlar ({songs.length})</Text>
                <Button type="primary" icon={<PlusOutlined />} onClick={openAdd}>Qo'shiq qo'shish</Button>
            </div>

            <Modal
                title={editRecord ? "Qo'shiqni tahrirlash" : "Yangi qo'shiq qo'shish"}
                open={modalOpen}
                onCancel={() => setModalOpen(false)}
                footer={null}
                destroyOnClose
            >
                <Form form={form} layout="vertical" onFinish={handleSubmit} requiredMark={false}>
                    <Form.Item name="title" label="Qo'shiq nomi" rules={[{ required: true, message: 'Nomini kiriting' }]}>
                        <Input placeholder="Masalan: Sevgi qo'shig'i" size="large" />
                    </Form.Item>
                    <Form.Item name="theme" label="Qo'shiq mavzusi">
                        <Input />
                    </Form.Item>
                    <Form.Item name="genre_id" label="Janr">
                        <Select options={genre.map(g=>({label: g.name, value: g.id}))} />
                    </Form.Item>
                    <Form.Item label="Audio yoki video fayl">
                        <UploadMedia setMediaUrl={setFilePath} mediaUrl={filePath} />
                    </Form.Item>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                        <Button onClick={() => setModalOpen(false)}>Bekor</Button>
                        <Button type="primary" htmlType="submit">Saqlash</Button>
                    </div>
                </Form>
            </Modal>

            <Table
                dataSource={songs}
                columns={columns}
                rowKey="id"
                size="small"
                pagination={false}
                locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Qo'shiqlar yo'q" /> }}
            />
        </div>
    );
}

export default Songs;
